import React, { useState, useEffect, useMemo } from 'react';
import {
  Grid,
  Card,
  CardContent,
  MenuItem,
  InputLabel,
  Select,
  CardActions,
  Button,
  FormControl,
  Typography,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  TextField,
  FormControlLabel,
  Input

} from "@mui/material"

import { Formik, Form, Field } from "formik"
import * as Yup from "yup"

import swal from 'sweetalert';
import FormatAlignJustifyOutlinedIcon from '@mui/icons-material/FormatAlignJustifyOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import Load from '../extra/Load'
import { ButtonGroup, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import SchoolIcon from '@mui/icons-material/School';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import SendIcon from '@mui/icons-material/Send';
import File from "../extra/File/File_original"
import { useMsal } from "@azure/msal-react";
import { ufe_listarArchivos } from '../function/axios';
import { ufe_avance_academico, ufe_cae_agregarArchivo, ufe_updateDatosCae } from '../function/axios';
import { getDatosCae } from '../store/slices/datosCae';
import { getArchiv } from '../store/slices/archiv';
import TextareaAutosize from '@mui/material/TextareaAutosize';

const fieldset = {
  width: '100%',
  height: '100%',
  marginBottom: 3,
  padding: 0,
  border: '1px solid #000',
  borderRadius: 3,
  backgroundColor: "rgb(255, 255, 255,0.9)",
  paddingTop: 1
}


const contenedorDeInformacion = {
  width: '100%',
  height: '100%',
  margin: 3,
  marginBottom: 3,
  padding: 0,
  border: '1px solid #000',
  borderRadius: 3,
  backgroundColor: "rgb(255, 255, 255,0.9)",
  paddingTop: 1
}




//password validation
// const lowercaseRegEx = /(?=.*[a-z])/
// const uppercaseRegEx = /(?=.*[A-Z])/
// const numericRegEx = /(?=.*[0-9])/
// const lengthRegEx = /(?=.{6,})/

//validation schema
// let validationSchema = Yup.object().shape({
//   firstName: Yup.string().required("Required"),
//   lastName: Yup.string().required("Required"),
//   email: Yup.string().email("Invalid email").required("Required"),
//   password: Yup.string()
//     .matches(
//       lowercaseRegEx,
//       "Must contain one lowercase alphabetical character!"
//     )
//     .matches(
//       uppercaseRegEx,
//       "Must contain one uppercase alphabetical character!"
//     )
//     .matches(numericRegEx, "Must contain one numeric character!")
//     .matches(lengthRegEx, "Must contain 6 characters!")
//     .required("Required!"),
// })

const UserForm = () => {
  const { accounts } = useMsal();
  const { datosCae } = useSelector(state => state.datosCae)
  const { archiv } = useSelector(state => state.archiv)
  const { estudiante } = useSelector(state => state.sesion)
  const { avance } = useSelector(state => state.avance)
  const dispatch = useDispatch()

  const [state, setState] = useState({
    CORREO_UGM: '',
    CAE_realiza_SM: '',
    RENO_CAE100_AREF: '',
    RENO_ESPECIFICA_MONTO_CAE: '',
    RENO_MONTO_0_CAE: '',
    RENO_MONTO_CAE_SOLICITA: ''
  });
  const [update, setUpdate] = useState(0);
  const [load, setLoad] = useState(false);
  const [file, setFile] = useState([]);
  const [data, setData] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [read, setRead] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [initialized, setInitialized] = useState(false);

  // Inicializar estado cuando los datos estén disponibles (solo una vez)
  useEffect(() => {
    if (datosCae.data && datosCae.data.length > 0 && !initialized) {
      console.log('useEffect - Inicializando estado. CAE_realiza_SM:', datosCae.data[0].CAE_realiza_SM);
      setState({
        CORREO_UGM: datosCae.data[0].Mail_UGM,
        CAE_realiza_SM: datosCae.data[0].CAE_realiza_SM,
        RENO_CAE100_AREF: datosCae.data[0].cae100_aran_ref,
        RENO_ESPECIFICA_MONTO_CAE: datosCae.data[0].espec_monto_cae,
        RENO_MONTO_0_CAE: datosCae.data[0].cae_0,
        RENO_MONTO_CAE_SOLICITA: datosCae.data[0].monto_CAE
      });
      setIsChecked(Boolean(parseInt(datosCae.data[0].CAE_realiza_SM)));
      setInitialized(true);
      console.log('useEffect - Estado inicializado. isChecked:', Boolean(parseInt(datosCae.data[0].CAE_realiza_SM)));
    }
  }, [datosCae, initialized]);

  // Verificar si los datos necesarios están cargados
  if (!datosCae.data || datosCae.data.length === 0 || !estudiante.sesion || estudiante.sesion.length === 0) {
    return <Load />
  }

  console.log(estudiante, "estudiante")

  //console.log("avance", avance.data[0])
  // //console.log("datosCae", datosCae.data[0])
  // //console.log("estudiante", estudiante)

  let arr = estudiante.sesion[0].rut.split('-');

  const rut = arr[0]

  // //console.log("carrera", estudiante.carrera[0].CODCARPR)
  var today = new Date();
  var year = today.getFullYear();



  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgb(37,44,95)',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,

    },
  }));



  function createData(name, calories, fat) {
    return { name, calories, fat };
  }


  function createDataMonto(primero, segundo, tercero, cuarto) {
    return { primero, segundo, tercero, cuarto };
  }



  // //console.log('data',data.data[0],"ggh")

  const obtenerFile = (archivo) => {

    //console.log("ads", archivo)

    setFile(archivo)
  }


  const onChange = (event) => {

    if (validacionCampos()) {

      const { name, value } = event.target

      setState({ ...state, [name]: value })
    }
  }

  const handleOnChange = () => {
    if (validacionCampos()) {
      console.log('handleOnChange - isChecked antes:', isChecked);
      setIsChecked(!isChecked);
      console.log('handleOnChange - isChecked después:', !isChecked);
    }
  };

  const handleChecked = (event) => {

    if (validacionCampos()) {

      const { name, value } = event.target
      console.log("handleChecked - eventos", { [name]: value }, "isChecked actual:", isChecked)

      // Si el usuario selecciona "SI" (value="1") en cualquiera de las opciones de monto CAE,
      // automáticamente poner las otras en "NO" (value="0")
      if (value === "1" && (name === "RENO_CAE100_AREF" || name === "RENO_ESPECIFICA_MONTO_CAE" || name === "RENO_MONTO_0_CAE")) {
        const newState = { ...state, [name]: value };

        // Desmarcar las otras opciones
        if (name !== "RENO_CAE100_AREF") newState.RENO_CAE100_AREF = "0";
        if (name !== "RENO_ESPECIFICA_MONTO_CAE") newState.RENO_ESPECIFICA_MONTO_CAE = "0";
        if (name !== "RENO_MONTO_0_CAE") newState.RENO_MONTO_0_CAE = "0";

        console.log("handleChecked - Opciones mutuamente excluyentes aplicadas:", newState);
        setState(newState);
      } else {
        setState({ ...state, [name]: value })
      }

    }


  }


  const valorMontoCaeSolicita = () => {

    return state.RENO_ESPECIFICA_MONTO_CAE == 0 ? 0 : state.RENO_MONTO_CAE_SOLICITA

  }




  const validacionCampos = () => {

    return (datosCae.data[0].esre_cod == 0 || datosCae.data[0].esre_cod == 4) ? true : false

  }


  //console.log("validacionCampos", validacionCampos())


  const onSubmit = (estado) => {

    // Solo aplicar validaciones estrictas al ENVIAR (estado === "E")
    // Al GUARDAR (estado === "G") permitir guardar borrador sin validaciones estrictas
    if (estado === "E") {

      // Validación 1: Verificar que el checkbox "Realizado Solicitud de Monto" esté marcado
      if (!isChecked) {
        swal({
          title: "Validación requerida",
          text: "Debe marcar el checkbox 'Realizado Solicitud de Monto' antes de enviar",
          icon: "warning",
          button: "Aceptar"
        });
        return;
      }

      // Validación 2: Verificar que exactamente UNA opción de monto esté seleccionada en "SI"
      const opcionesSeleccionadas = [
        state.RENO_CAE100_AREF,
        state.RENO_ESPECIFICA_MONTO_CAE,
        state.RENO_MONTO_0_CAE
      ].filter(opcion => opcion === "1");

      if (opcionesSeleccionadas.length === 0) {
        swal({
          title: "Selección requerida",
          text: "Debe seleccionar una opción de monto de CAE (100%, Monto Específico o Monto Cero)",
          icon: "warning",
          button: "Aceptar"
        });
        return;
      }

      if (opcionesSeleccionadas.length > 1) {
        swal({
          title: "Solo una opción",
          text: "Solo puede seleccionar UNA opción de monto de CAE. Por favor, revise sus selecciones.",
          icon: "warning",
          button: "Aceptar"
        });
        return;
      }

      // Validación 3: Si seleccionó "Monto Específico", debe ingresar un monto válido
      if (state.RENO_ESPECIFICA_MONTO_CAE === "1") {
        const monto = parseInt(state.RENO_MONTO_CAE_SOLICITA);
        if (!monto || monto < 200000) {
          swal({
            title: "Monto inválido",
            text: "El monto específico debe ser igual o superior a $200.000",
            icon: "warning",
            button: "Aceptar"
          });
          return;
        }
      }
    }

    let CAE_realiza_SM

    if (isChecked === true) {
      CAE_realiza_SM = "1"
    } else {
      CAE_realiza_SM = "0"
    }




    // const array = { ...state, CAE_realiza_SM: CAE_realiza_SM, GUARDAR_ENVIAR: estado }
    const form = new FormData();
    form.append('rut_estudiante', datosCae.data[0].rut)
    form.append('RENO_CAE100_AREF', state.RENO_CAE100_AREF)
    form.append('RENO_ESPECIFICA_MONTO_CAE', state.RENO_ESPECIFICA_MONTO_CAE)
    form.append('RENO_MONTO_0_CAE', state.RENO_MONTO_0_CAE)
    form.append('CAE_realiza_SM', CAE_realiza_SM)
    form.append('CORREO_UGM', state.CORREO_UGM)
    form.append('GUARDAR_ENVIAR', estado)
    form.append('RENO_MONTO_CAE_SOLICITA', state.RENO_MONTO_CAE_SOLICITA)
    //console.log('f', file)
    file.map((value, index) => {
      form.append('files[]', value)
    })





    // //console.log('array', array)

    ufe_updateDatosCae(form)
      .then((resp) => {
        setLoad(true)
        //console.log('respuesta', resp)
      })
      .catch((error) => {
        console.error('Error en submit:', error);
      })
      .finally(() => {
        setLoad(false);
        setFile([]);
        // Recargar datos del servidor después del submit (éxito o error)
        dispatch(getDatosCae(accounts));
        dispatch(getArchiv({ rut_estudiante: datosCae.data[0].rut, tipo_proceso: 'CAE' }));
      })







    // ufe_cae_agregarArchivo(form).then((resp) => {

    //   //console.log("respArchivos", resp)

    // }).finally(() => {

    //   setLoad(false)
    //   dispatch(getArchiv({rut_estudiante: datosCae.data[0].rut, tipo_proceso: 'CAE'}))
    // })

  }



  const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0
  })


  if (load) {
    return (<Load />)
  } else {

    // //console.log("data", data.data[0]["AA>70%"])

    // //console.log('state', state)
    const rows = [

      createData(<Grid container spacing={4} justify="center">

        <Grid sx={{ paddingLeft: 4, fontSize: 14 }} xs={12}>

          Alumno Renovante de CAE

        </Grid>

        <Grid sx={{ paddingTop: 5 }} />
        <Grid xs={12} md={4}>
          <div>

            <FormControlLabel sx={{ paddingLeft: 2 }} labelPlacement="start" title={datosCae.data[0].EA_ESTADO} label={<Typography sx={{ fontSize: 14 }}>E.A</Typography>} control={<Checkbox sx={{ paddingLeft: 2, width: 20 }} InputProps={{ readOnly: true }} id="standard-basic" checked={parseInt(datosCae.data[0].EA)} variant="standard" />} />
            {/*    <FormControlLabel labelPlacement="start" label="Renov-CAE Beneficio" control={<Checkbox />} />
            <figcaption style={{ paddingTop: 10 }}>{datosCae.data[0].EA_ESTADO}</figcaption> */}

          </div>

        </Grid>

        <Grid xs={12} md={4}>


          <FormControlLabel labelPlacement="start" sx={{ paddingLeft: 2 }} label={<Typography sx={{ fontSize: 14 }}>A.F</Typography>} control={<Checkbox sx={{ paddingLeft: 2, width: 20 }} InputProps={{ readOnly: true }} id="standard-basic" checked={parseInt(datosCae.data[0].AF)} variant="standard" />} />
        </Grid>

        <Grid xs={12} md={4}>
          <FormControlLabel labelPlacement="start" sx={{ paddingLeft: 2 }} label={<Typography sx={{ fontSize: 14 }}>A.M.F</Typography>} control={<Checkbox id="standard-basic" InputProps={{ readOnly: true }} sx={{ paddingLeft: 2, width: 20 }} checked={parseInt(datosCae.data[0].AMF)} variant="standard" />} />
        </Grid>

      </Grid>,

        <FormControlLabel labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>Renov-CAE Beneficio</Typography>} control={<Checkbox checked={parseInt(datosCae.data[0].benef_CAE)} />} />,

        <Grid container justify="center" sx={{ backgroundColor: 'rgb(97,183,228)', border: 1, padding: 2 }}>
          <Grid />
          <Grid xs={12} sx={{ fontSize: 14 }}>
            En el caso de Renovante CAE se debe completar monto en <a href="https://www.ingresa.cl" target="_blank">www.ingresa.cl</a>
          </Grid>
          <Grid sx={{ paddingTop: 4 }} />
          {/* <Grid xs={6}>

            <FormControlLabel labelPlacement="start" label="Pendiente realización SM" control={<Checkbox />} />

          </Grid> */}

          <Grid md={12}>

            <FormControlLabel value="1" labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>Realizado Solicitud de Monto</Typography>} control={<Checkbox name="CAE_realiza_SM" checked={isChecked}
              onChange={handleOnChange} />} />

          </Grid> </Grid>),

      createData(<Grid container spacing={4} justify="center">
        <Grid sx={{ paddingTop: 2 }} />
        <Grid sx={{ paddingLeft: 4, fontSize: 14 }} xs={12}>

          Alumno Renovante de Beca Ministerial

        </Grid>

        <Grid xs={12} md={4}>

          <FormControlLabel sx={{ paddingLeft: 2 }} labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>RI</Typography>} control={<TextField id="standard-basic" InputProps={{ readOnly: true }} sx={{ paddingLeft: 3, width: 30 }} defaultValue={avance.data[0].RI} variant="standard" />} />

        </Grid>

        <Grid xs={12} md={4}>


          <FormControlLabel sx={{ paddingLeft: 2 }} labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>R.A</Typography>} control={<TextField id="standard-basic" InputProps={{ readOnly: true }} sx={{ paddingLeft: 3, width: 30 }} defaultValue={avance.data[0].RA} variant="standard" />} />
        </Grid>
        <Grid xs={12} md={4}>


          <FormControlLabel sx={{ paddingLeft: 2 }} labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>AA%</Typography>} control={<TextField InputProps={{ readOnly: true }} id="standard-basic" sx={{ paddingLeft: 3, width: 30 }} defaultValue={avance.data[0].AA} variant="standard" />} />
        </Grid> </Grid>, <FormControlLabel labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>Renov-BM Beneficio</Typography>} control={<Checkbox checked={parseInt(datosCae.data[0].benef_BM)} />} />, <Grid>

        <Grid xs={12}>


          <FormControlLabel labelPlacement="start" label={<Typography sx={{ fontSize: 14 }}>Alumno que pasa a 2° Año en adelante Cumple con AA 70%</Typography>} control={<Checkbox id="standard-basic" checked={parseInt(avance.data[0]["AA>70%"])} variant="standard" />} />
        </Grid>


      </Grid>)
    ];




    const montos2 = [

      //   createDataMonto(

      //     <Grid fontSize={16}>

      //       Monto de CAE a Solicitar

      //     </Grid>
      //     ,
      //     <Grid>

      //       Renovación del Monto CAE

      //     </Grid>,

      //     <Grid>

      //       <TextField id="standard-basic" onChange={onChange} variant="standard" />

      //     </Grid>

      //   ),

      createDataMonto(

        <Grid sx={{ fontSize: 14 }}>

          Beca Ministerial a Renovar

        </Grid>,

        <Grid>
          <TextField value={datosCae.data[0].beca_ministerial} id="standard-basic" variant="standard" inputProps={{ readOnly: true, style: { fontSize: 12 } }} />
        </Grid>,

        <Grid sx={{ fontSize: 14 }}>

          Beca Ministerial Renovar Monto

        </Grid>,

        <Grid>

          <TextField id="standard-basic" name={"hola"} value={formatterPeso.format(datosCae.data[0].bm_monto)} onChange={onChange} inputProps={{ readOnly: true, style: { fontSize: 12 } }} variant="standard" />

        </Grid>

      )

      //   createDataMonto(

      //     <Grid fontSize={16}>

      //       Total de Beneficios Estatales

      //     </Grid>
      //     ,
      //     <Grid >

      //       Renovación Total de Beneficios

      //     </Grid>
      //     ,

      //     <Grid>

      //       <TextField id="standard-basic" variant="standard" />

      //     </Grid>

      //   )
    ];

    if (load) {

      return <Load />

    } else {

      return (


        <Grid
          i tem
          xs={12}
          md={10}
          sx={{ marginY: '30px ' }}

        >


          <Box sx={fieldset} component="fieldset" >

            <Typography variant="h5" >  FORMULARIO PASE DE MATRICULA CON DERECHO A RENOVACIÓN DE CAE Y/O BECA MINISTERIAL </Typography>

            <Grid sx={{ paddingTop: 2 }} />

            <Typography variant="h5"  > Estado de la solicitud: <n style={{ color: 'rgb(97,183,228)' }}>{datosCae.data[0].esre_descripcion} </n></Typography>

            <Grid sx={{ paddingTop: 2 }} />

            <Formik
              initialValues={datosCae.data[0]}

              onSubmit={onSubmit}>
              {({ values, handleChange }) => {
                return (
                  <Grid>
                    <CardContent sx={{ paddingLeft: 3, paddingRight: 3 }}>
                      <Grid container spacing={4} justify="center">


                        <Grid item xs={12} md={2}>
                          <Field
                            label="Rut"
                            variant="outlined"
                            fullWidth
                            name="rut"
                            value={values.rut}
                            component={TextField}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }

                            }}

                          />
                        </Grid>



                        <Grid item xs={12} md={6}>
                          <Field
                            label="Alumno"
                            variant="outlined"
                            fullWidth
                            name="names"
                            value={values.Alumno}
                            component={TextField}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <Field
                            label="Fecha De Nacimiento"
                            variant="outlined"
                            fullWidth
                            name="apellidos"
                            type="date"
                            inputFormat="DD/MM/YYYY"
                            value={values.Fecha_nac}
                            component={TextField}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                          />
                        </Grid>

                        <Grid item md={2} xs={12}>
                          <Field
                            label="Año de ingreso"
                            variant="outlined"
                            fullWidth
                            name="fecha_ingreso"
                            value={values.Agno_ingreso}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                            component={TextField}
                          />
                        </Grid>


                        <Grid item md={8} xs={12}>
                          <Field
                            label="Carrera"
                            variant="outlined"
                            fullWidth
                            name="carerra"
                            value={values.Carrera}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                            component={TextField}
                          />
                        </Grid>

                        <Grid item md={4} xs={12}>
                          <Field
                            label="Tipo Carrera"
                            variant="outlined"
                            fullWidth
                            name="carerra"
                            value={values.Carrera_S_T}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                            component={TextField}
                          />
                        </Grid>




                        <Grid sx={{ marginTop: 1 }} />

                        <Grid item xs={12} md={6} >
                          <Field
                            label="Direccion"
                            variant="outlined"
                            fullWidth
                            name="direccion"
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                            value={values.Direccion}
                            onChange={handleChange}
                            component={TextField}
                          />

                        </Grid>

                        <Grid item xs={12} md={6} >
                          <Field
                            label="Comuna"
                            variant="outlined"
                            fullWidth
                            name="region"
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 12 }
                            }}
                            value={values.Comuna}
                            onChange={handleChange}
                            component={TextField}
                          />
                        </Grid>

                        <Grid item xs={12} md={6} >
                          <Field
                            label="Region"
                            variant="outlined"
                            fullWidth
                            name="region"
                            value={values.Region}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 12 }
                            }}
                            onChange={handleChange}
                            component={TextField}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Field
                            label="Movil"
                            variant="outlined"
                            fullWidth
                            name="movil"
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 14 }
                            }}
                            value={values.Fono_Part}
                            onChange={handleChange}
                            component={TextField}
                          />
                        </Grid>


                        <Grid item xs={12} md={6}>
                          <Field
                            label="Correo Personal"
                            variant="outlined"
                            fullWidth
                            name="email"
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 12 }

                            }}
                            value={values.Mail_Personal}
                            onChange={handleChange}
                            component={TextField}
                          />
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Field
                            label="Correo Institucional"
                            variant="outlined"
                            fullWidth
                            name="email"
                            value={values.Mail_UGM}
                            component={TextField}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 12 }
                            }}
                          />
                        </Grid>

                      </Grid>

                    </CardContent>



                    <CardContent sx={{
                      marginX: 3,
                      fontSize: 14,
                      textAlign: 'justify',
                      lineHeight: 2
                    }} component="fieldset">
                      Intrucciones<p />
                      Para editar mis datos personales ingresar <a href="https://alumnosnet.ugm.cl/Actualizador.asp" target="_blank">AQUÍ</a><br />
                      Todos los campos marcados en <font style={{ backgroundColor: 'rgb(97,183,228)' }}>celeste</font> son los campos editables
                      <br /> Recordar que de se deben subir los siguentes archivos:
                      <b> Solicitud monto ingresa,
                        Cedula de identidad ambos lados</b>
                    </CardContent>



                    <Grid sx={{ marginTop: 2 }} />



                    <Grid container justify="left" sx={{ paddingLeft: 3, paddingRight: 3 }}>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Tipo de Beneficiario</TableCell>
                              <TableCell align='left' >Beneficio</TableCell>
                              <TableCell align="left" >Observación</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>

                            {rows.map((row) => (
                              <TableRow key={row.name}>
                                <TableCell align='left' >
                                  {row.name}
                                </TableCell>
                                <TableCell align="left">{row.calories}</TableCell>
                                <TableCell align="left">{row.fat}</TableCell>

                              </TableRow>
                            ))}

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Grid>

                    <Grid container justify="center" sx={{ paddingLeft: 3, paddingRight: 3 }}>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">

                          <TableBody>

                            {
                              <TableRow >
                                <TableCell align='left' >
                                  <Grid fontSize={12}>

                                    <Typography sx={{ fontWeight: 'bold' }} variant="h6"> Monto de CAE a solicitar 100% del arancel de referencia de la carrera. </Typography>

                                    Este monto no podrá exceder el valor que Mineduc determinó como arancel de referencia
                                    para la carrera en la que se encuentra matriculado/a. Para conocer el arancel de referencia
                                    puedes revisarlos <a href="https://portal.beneficiosestudiantiles.cl/aranceles-de-referencia" target="_blank">AQUÍ</a>

                                  </Grid>

                                </TableCell>

                                <TableCell sx={{ backgroundColor: 'rgb(97,183,228)', border: 1, alignSelf: "center", paddingRight: 6 }} align="left"> <Grid >

                                  <FormControl>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="RENO_CAE100_AREF"
                                      value={state.RENO_CAE100_AREF}
                                      onChange={handleChecked}
                                    >
                                      <Grid container justify="center">
                                        <Grid xs={6}>
                                          <FormControlLabel value="1" control={<Radio />} labelPlacement="top" label={<Typography sx={{ fontSize: 14 }}>SI</Typography>} />
                                        </Grid>
                                        <Grid xs={6}>
                                          <FormControlLabel value="0" control={<Radio />} label={<Typography sx={{ fontSize: 14 }}>NO</Typography>} labelPlacement="top" />
                                        </Grid>
                                      </Grid>
                                    </RadioGroup>
                                  </FormControl>

                                </Grid>
                                </TableCell>

                              </TableRow>

                            }
                            <TableRow >
                              <TableCell sx={{ backgroundColor: 'rgb(97,183,228)', border: 1 }}>

                                <Grid sx={{ fontSize: 12 }}>

                                  <Typography sx={{ fontWeight: 'bold' }} variant="h6">Monto Específico (menor al arancel de referencia)</Typography>
                                  <Grid  >  Especificar Monto $ <FormControlLabel labelPlacement="start" control={<TextField name="RENO_MONTO_CAE_SOLICITA" value={valorMontoCaeSolicita()} type="number" onChange={onChange} variant="standard" inputProps={{ style: { fontSize: 12 } }} />} /></Grid>

                                  Monto igual o superior a $200.000 anual y menor al arancel de referencia {year}. Para
                                  conocer el arancel de referencia puedes revisarlos <a href="https://portal.beneficiosestudiantiles.cl/aranceles-de-referencia/" target="_blank">AQUÍ</a>


                                </Grid>


                              </TableCell>
                              <TableCell sx={{ backgroundColor: 'rgb(97,183,228)', border: 1, alignSelf: "center", paddingRight: 6 }}>

                                <Grid >
                                  <FormControl>

                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="RENO_ESPECIFICA_MONTO_CAE"
                                      value={state.RENO_ESPECIFICA_MONTO_CAE}
                                      onChange={handleChecked}
                                    >
                                      <Grid container justify="center">
                                        <Grid xs={6}>
                                          <FormControlLabel value="1" control={<Radio />} labelPlacement="top" label={<Typography sx={{ fontSize: 14 }}>SI</Typography>} />
                                        </Grid>
                                        <Grid xs={6}>
                                          <FormControlLabel value="0" control={<Radio />} label={<Typography sx={{ fontSize: 14 }}>NO</Typography>} labelPlacement="top" />
                                        </Grid>
                                      </Grid>
                                    </RadioGroup>
                                  </FormControl>

                                </Grid>


                              </TableCell>



                            </TableRow>



                            <TableRow>

                              <TableCell>
                                <Grid fontSize={12}>

                                  <Typography sx={{ fontWeight: 'bold' }} variant="h6"> Monto Cero </Typography>
                                  Esto significa que pedirás monto cero para este año pero firmarás igual el CAE para
                                  disponer de éste en años siguientes, en caso que lo llegues a necesitar.

                                </Grid>

                              </TableCell>

                              <TableCell sx={{ backgroundColor: 'rgb(97,183,228)', border: 1, alignSelf: "center", paddingRight: 6 }}>

                                <Grid  >
                                  <FormControl>

                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="RENO_MONTO_0_CAE"
                                      value={state.RENO_MONTO_0_CAE}

                                      onChange={handleChecked}

                                    >
                                      <Grid container justify="center">
                                        <Grid xs={6}>
                                          <FormControlLabel value="1" control={<Radio />} labelPlacement="top" label={<Typography sx={{ fontSize: 14 }}>SI</Typography>} />
                                        </Grid>
                                        <Grid xs={6}>
                                          <FormControlLabel value="0" control={<Radio />} label={<Typography sx={{ fontSize: 14 }}>NO</Typography>} labelPlacement="top" />
                                        </Grid>
                                      </Grid>
                                    </RadioGroup>
                                  </FormControl>

                                </Grid>

                              </TableCell>

                            </TableRow>


                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Grid>

                    <Grid container justify="center" sx={{ paddingLeft: 3, paddingRight: 3 }}>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">

                          <TableBody>

                            {montos2.map((row) => (
                              <TableRow >
                                <TableCell align='left' component="th" scope="row">
                                  {row.primero}
                                </TableCell>
                                <TableCell align="left">{row.segundo}</TableCell>
                                <TableCell align="left">{row.tercero}</TableCell>
                                <TableCell align="left">{row.cuarto}</TableCell>
                              </TableRow>
                            ))}

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Grid>

                    {(datosCae.data[0].esre_cod == 0 || datosCae.data[0].esre_cod == 4) &&
                      <Grid container justify="center" sx={{ paddingLeft: 3, paddingRight: 3, paddingTop: 2 }}>

                        <File tipo={1} update={update} set={obtenerFile} rut={datosCae.data[0].rut} />

                      </Grid>
                    }

                    {(archiv.length > 0) &&
                      <Grid container justify="center" sx={{ paddingLeft: 3, paddingRight: 3, paddingTop: 2 }}>
                        <File tipo={2} set={obtenerFile} />
                      </Grid>
                    }
                    <Grid sx={{ paddingTop: 2 }} />


                    {(datosCae.data[0].esre_cod >= 4 && datosCae.data[0].observacion && datosCae.data[0].observacion.length > 0) &&
                      <Grid >
                        <Typography variant="h6"  > Estado de la solicitud: <n style={{ color: 'rgb(97,183,228)' }}>{datosCae.data[0].esre_descripcion} </n></Typography>

                        <Grid sx={{ paddingTop: 2 }} />

                        <Grid item xs={12}>

                          <TextareaAutosize
                            aria-label="minimum height"
                            minRows={10}
                            placeholder="Minimum 3 rows"
                            name="declaracion"
                            value={datosCae.data[0].observacion}
                            readOnly
                            onChange={handleChange}
                            maxLength={500}
                            style={{ width: "94%", height: "40vh", backgroundColor: "rgb(255, 255, 255,0.4)", }}
                          />

                        </Grid>

                        <Grid sx={{ paddingTop: 2 }} />
                      </Grid >
                    }

                    <CardContent>
                      <Grid item container spacing={4} justify="center">
                        {(datosCae.data[0].esre_cod == 0 || datosCae.data[0].esre_cod == 4) &&
                          <Grid item xs={12}>
                            <CardActions>
                              <ButtonGroup fullWidth>
                                <Button onClick={() => onSubmit("G")}/* disabled={disable}*/ sx={{ backgroundColor: 'rgb(37,44,95)' }} name='G' variant="contained" size="large"><SaveIcon />guardar</Button>
                                <Button onClick={() => onSubmit("E")} /* disabled={disable}*/ sx={{ backgroundColor: 'rgb(37,44,95)' }} type='submit' name='E' variant="contained" >Enviar <SendIcon /></Button>
                              </ButtonGroup>
                            </CardActions>
                          </Grid>
                        }
                      </Grid>
                    </CardContent>

                  </Grid>
                )
              }}
            </Formik>
          </Box>

        </Grid>


      )
    }

  }
}
export default UserForm


